jQuery(function ($) {
	"use strict";

	let mainSwiper = null;
	let thumbsSwiper = null;

	function initSwiper() {
		if (window.innerWidth < 1023 && !mainSwiper) {
			// Тумбси (максимум 4)
			thumbsSwiper = new Swiper(".product-detail__thumbs", {
				slidesPerView: 4,
				spaceBetween: 8,
				slideToClickedSlide: true,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				// slideActiveClass: "swiper-slide-thumb-active",
			});

			// Основний слайдер
			mainSwiper = new Swiper(".product-detail__slider", {
				slidesPerView: 1,
				spaceBetween: 8,
				breakpoints: {
					0: { slidesPerView: 1 },
					768: { slidesPerView: 2 },
				},
				thumbs: {
					swiper: thumbsSwiper,
				},
				on: {
					slideChange: function () {
						// Прокручуємо тумби до активного слайду
						if (thumbsSwiper) {
							thumbsSwiper.slideTo(this.activeIndex);
						}
					},
				},
			});

			// Якщо тумби можуть додаватися динамічно, оновлюємо thumbsSwiper
			// (наприклад після ajax або додавання нових елементів)
			thumbsSwiper.update();
		} else if (window.innerWidth >= 1023 && mainSwiper) {
			// Знищуємо обидва
			mainSwiper.destroy(true, true);
			thumbsSwiper.destroy(true, true);

			mainSwiper = null;
			thumbsSwiper = null;
		}
	}

	// Ініціалізація
	initSwiper();
	$(window).on("resize", initSwiper);

	// Автоматичне відтворення відео
	const videos = document.querySelectorAll(".product__video");
	videos.forEach((video) => {
		video.play().catch(() => {});
	});

	const mainSlider = new Swiper(".more-offer__slider", {
		slidesPerView: 4,
		spaceBetween: 12,
		navigation: {
			nextEl: ".more-offer__header .swiper-button-next",
			prevEl: ".more-offer__header .swiper-button-prev",
		},
		breakpoints: {
			0: {
				slidesPerView: 2.3,
			},
			768: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
			},
		},
	});

	// $(document).ready(function () {
	//   const $gallery = $("#engraving-gallery");
	//   const $items = $gallery.find(".gallery-item");
	//   const $hidden = $("#engraving-selected");

	//   $items.on("click", function () {
	//     // зняти active з усіх
	//     $items.removeClass("active");

	//     // додати active на вибране
	//     $(this).addClass("active");

	//     // взяти id (або src, якщо треба)
	//     const selectedId = $(this).data("id");

	//     // записати у hidden input
	//     $hidden.val(selectedId);
	//   });

	//   stickyBottomInfoProduct();
	// });

	$(document).ready(function () {
		let engravingThumbs = null;
		let engravingSwiper = null;
		const $hidden = $("#engraving-selected");

		function initEngravingSwiper() {
			if (engravingSwiper || !document.querySelector(".engraving-swiper")) return;
			const engravingSlideCount = document.querySelectorAll(
				".engraving-swiper .swiper-wrapper > .swiper-slide"
			).length;
			const engravingLoop = engravingSlideCount > 4;

			engravingThumbs = new Swiper(".engraving-thumbs", {
				slidesPerView: 4,
				spaceBetween: 8,
				initialSlide: 1,
				watchSlidesProgress: true,
				slideToClickedSlide: true,
				centerInsufficientSlides: true,
				loop: engravingLoop,
			});

			engravingSwiper = new Swiper(".engraving-swiper", {
				slidesPerView: 3,
				initialSlide: 1,
				spaceBetween: 46,
				centeredSlides: true,
				loop: engravingLoop,
				thumbs: {
					swiper: engravingThumbs,
				},
				navigation: {
					nextEl: ".engraving-next",
					prevEl: ".engraving-prev",
				},
				breakpoints: {
					0: {
						slidesPerView: 1.8,
						centeredSlides: true,
					},
					700: {
						slidesPerView: 3,
						centeredSlides: true,
					},
				},
			});

			engravingSwiper.on("slideChange", function () {
				const activeSlide = engravingSwiper.slides[engravingSwiper.activeIndex];
				const id = $(activeSlide).data("id");

				$hidden.val(id);
			});
		}

		$(document).on("click", ".open-popup[data-rel='engraving-popup']", function () {
			window.requestAnimationFrame(function () {
				initEngravingSwiper();
				if (engravingSwiper) engravingSwiper.update();
			});
		});

		$(document).on("click", ".engraving-gallery .gallery-item", function () {
			initEngravingSwiper();

			if (!engravingSwiper) return;

			$(".engraving-gallery .gallery-item").removeClass("active");

			$(this).addClass("active");

			const index = $(this).closest(".swiper-slide").index();
			const selectedId = $(this).data("id");

			engravingSwiper.slideTo(index, 300);
			$hidden.val(selectedId);
		});

		stickyBottomInfoProduct();
	});
});

function stickyBottomInfoProduct() {
	const $sticky = $(".product-sticky");
	const $buttons = $(".product-detail__content-buttons");
	const $footer = $(".footer");

	if ($sticky.length === 0 || $buttons.length === 0) return;

	let lastScrollTop = 0;
	let scrollUpStart = null;
	const scrollUpThreshold = 50;

	function isInViewport($el) {
		const elementTop = $el.offset().top;
		const elementBottom = elementTop + $el.outerHeight();

		const viewportTop = $(window).scrollTop();
		const viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	}

	function updateSticky() {
		const scrollTop = $(window).scrollTop();

		const buttonsBottom =
			$buttons.offset().top + $buttons.outerHeight();

		const footerTop = $footer.offset().top;
		const windowBottom = scrollTop + $(window).height();

		const footerVisible = windowBottom >= footerTop;
		const buttonsVisible = isInViewport($buttons);

		if (buttonsVisible || footerVisible) {
			$sticky.removeClass("active");
			lastScrollTop = scrollTop;
			scrollUpStart = null;
			return;
		}

		const scrollingDown = scrollTop > lastScrollTop;

		if (scrollingDown) {
			scrollUpStart = null;
			$sticky.removeClass("active");
		} else {
			if (scrollUpStart === null) {
				scrollUpStart = lastScrollTop;
			}

			const scrolledUpDistance = scrollUpStart - scrollTop;

			if (
				scrollTop >= buttonsBottom &&
				scrolledUpDistance >= scrollUpThreshold
			) {
				$sticky.addClass("active");
			} else {
				$sticky.removeClass("active");
			}
		}

		lastScrollTop = scrollTop;
	}

	$(window).on("scroll resize", updateSticky);
	updateSticky();
}
